(() => {
  const init = () => {
    const tabs = [...document.querySelectorAll('[data-ct-shop-tab]')];
    const panels = [...document.querySelectorAll('[data-ct-shop-panel]')];
    if (!tabs.length || !panels.length) return;
    if (tabs[0].dataset.ctReady) return;
    tabs[0].dataset.ctReady = 'true';
    const activate = (name, updateHash = false) => {
      if (!tabs.some(t => t.dataset.ctShopTab === name)) return;
      tabs.forEach(t => { const on=t.dataset.ctShopTab===name; t.classList.toggle('is-active',on); t.setAttribute('aria-selected',on?'true':'false'); t.tabIndex = on ? 0 : -1; });
      panels.forEach(p => { const on=p.dataset.ctShopPanel===name; p.classList.toggle('is-active',on); p.hidden=!on; });
      if (updateHash) history.replaceState(null, '', '#ct-shop-' + name);
    };
    const fromHash = () => activate(location.hash.replace('#ct-shop-', ''));
    tabs.forEach((t, index) => {
      t.addEventListener('click', () => activate(t.dataset.ctShopTab, true));
      t.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next].dataset.ctShopTab, true);
        tabs[next].focus();
      });
    });
    window.addEventListener('hashchange', fromHash);
    fromHash();
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
